import type { AssetIndicatorsProps } from "./asset-indicators.type";

import ConditionRating from "@/components/Asset/ConditionRating";
import { AssetRiskAvatar } from "@/modules/asset/asset-risk-avatar";

import "./asset-indicators.style.less";

export const AssetIndicators = ({ asset }: AssetIndicatorsProps) => {
  return (
    <div className="asset-indicators">
      {asset?.condition_rating && (
        <ConditionRating condition={asset.condition_rating} />
      )}
      <AssetRiskAvatar asset={asset} />
    </div>
  );
};
